import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { finalize, Observable } from 'rxjs';
import { ServiceDto } from '@shared/interfaces/dtos/services';
import { Service } from '@shared/interfaces/services';

@Injectable({
  providedIn: 'root',
})
export class ServicesService extends BaseHttpService {
  protected endPoint: string = 'Global/Services';

  /**
   *
   * @param options - flattened: boolean to specify if the services should be returned in a flattened structure or not, parents and children will be at same level if true, otherwise children will be nested in their parent
   */
  public fetchServices(options?: { flattened?: boolean }): Observable<ServiceDto[]> {
    const { flattened = false } = options || {};
    return this.http.get<ServiceDto[]>(this.buildURL({ apiScope: 'iAdmin' }));
  }

  public fetchMyOwnServices(): Observable<ServiceDto[]> {
    this.endPoint = 'Me/Services';
    return this.http.get<ServiceDto[]>(this.buildURL({ apiScope: 'iAdmin' })).pipe(finalize(() => this.resetBaseURL()));
  }

  public getServiceChildren(service: Service | ServiceDto, allServices: ServiceDto[]): ServiceDto[] {
    const children = allServices.filter((s) => s.parentId === service.id);
    return children;
  }
}
